interface Props {
  color: string;
  size: number;
}

export function Gateway({ color, size }: Props) {
  return (
    <svg width={24 * size} viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.2 12.55V8.45C2.2 4.45 5.65 2.15 12 2.15C18.35 2.15 21.8 4.45 21.8 8.45V12.55C21.8 16.75 18.45 18.85 12 18.85C5.55 18.85 2.2 16.75 2.2 12.55Z"
        fill="white"
        stroke={color}
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
      <path
        d="M1.45 12.55V8.45C1.45 3.9 5.35 1.4 12 1.4C18.65 1.4 22.55 3.9 22.55 8.45V12.55C22.55 17.25 18.7 19.6 12 19.6C5.3 19.6 1.45 17.25 1.45 12.55Z"
        stroke="#323B37"
        strokeWidth="0.45"
        strokeLinejoin="round"
      />
      <ellipse cx="12" cy="10.5" rx="6.9" ry="6.45" fill={color} />
      <line
        x1="12"
        y1="8"
        x2="12"
        y2="13"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="14.5"
        y1="10.5"
        x2="9.5"
        y2="10.5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
